// Export trigger for the reporting top nav. Opens the shared cross-app
// download modal (DownloadForm, in libs/react/src/lib/domains/sessions/
// components.tsx) rather than rendering its own dropdown, mirroring Match
// Tracker's own SessionCard "Download" action
// (libs/match-tracker-legacy/.../SessionCard/hooks.tsx's openDownloadModal):
// a hook (useExportModal) builds the modal payload and returns an
// open*Modal function, wired to this button's onClick. For soccer the modal
// carries a General / Tracking tab split; other sports see the flat form.
import type { ReportingSport } from '@frontend/core/lib/domains/reporting/types'
import { Button } from '@frontend/ui'
import { Download } from 'lucide-react'
import { useExportModal } from '../lib/use-export-modal'

interface ExportButtonProps {
  sessionId: string
  sessionDate: string
  sessionName: string
  sport: ReportingSport
}

export function ExportButton({
  sessionId,
  sessionDate,
  sessionName,
  sport
}: ExportButtonProps) {
  const { openExportModal } = useExportModal({
    sessionId,
    sessionDate,
    sessionName,
    sport
  })

  return (
    <Button variant='ghost' className='print:hidden' onClick={openExportModal}>
      <Download className='mr-2 h-4 w-4' />
      Export
    </Button>
  )
}
